import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const list: Readonly<Array<ItemVM>> = Object.freeze([
  {
    id: 'ALWAYS',
    value: 'Invia Email al termine',
  },
  {
    id: 'ON_ERROR ',
    value: 'Invia Email se in errore ',
  },
]);

interface PostCalculationListProps {
  value: string;
  disabled?: boolean;
  error?: boolean;
  onChange: (type?: SelectChangeEvent<string>) => void;
  label?: string;
  required?: boolean;
  id?: string;
}

const PostCalculationListComponent = ({
  value,
  disabled,
  onChange,
  required,
  error,
  label = 'Post elaborazione',
  id = 'postExecution',
}: PostCalculationListProps): React.ReactElement => {
  const idTag = `${id}-${label}`;
  return (
    <PmiFormControl fullWidth>
      <InputLabel id={idTag}>{required ? `${label} *` : label}</InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        error={error}
        label={required ? `${label} *` : label}
        disabled={disabled}
        value={value}
        onChange={onChange}
      >
        <MenuItem value="NEVER">
          <em>Nessuna</em>
        </MenuItem>
        {list.map((status: ItemVM) => (
          <MenuItem key={status.id} value={status.id}>
            {status.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

PostCalculationListComponent.displayName = 'Post calculation list Select';

export const PostCalculationList = memo(
  PostCalculationListComponent
) as typeof PostCalculationListComponent;

export default PostCalculationList;
